import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { ArrowCircleRightIcon } from '../../img/icons';
import { useHeaderFooter } from '../../hooks';

import messages from './messages';

import heroImg from '../../img/broughtToYou/BROUGHT-TO-YOU-BY-Header.jpg';
import logo1Img from '../../img/broughtToYou/Legatum_Primary_Logo 1.png';
import oxfordLogoImg from '../../img/broughtToYou/Oxford-Logo.png';
import harvardLogoImg from '../../img/broughtToYou/harvard-humar-flourishing-prog.png';

interface BroughtToYouProps {
  children?: React.ReactNode;
}

const BroughtToYou: React.FC<BroughtToYouProps> = ({ children }) => {
  const { headerContent, footerContent } = useHeaderFooter(children);
  const intl = useIntl();

  return (
    <>
      <input type="hidden" id="anPageName" name="page" defaultValue="about" />
      <div className="container-center-horizontal">
        <div className="about screen contact">
          <div className="homepage ">
            {headerContent}
            <div className="overlap-group6">
              <div className="hero-image">
                <div className="overlap-group-1">
                  <img
                    className="overlap-group-item"
                    src={heroImg}
                    alt=""
                  />
                  <h1 className="about-us recklessneue-regular-normal-white-100-1px">
                    <span className="recklessneue-regular-normal-white-100-1px">
                      {intl.formatMessage(messages.title)}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="course-overview-text">
            <div className="overlap-group5">
              <p className="lorem-ipsum-dolor-si-1 neuehaasgroteskdisplaypro-45-light-congress-blue-24px">
                {intl.formatMessage(messages.courseDeveloped)}
              </p>
            </div>
          </div>
          <div className="brought-row">
            <div className="brought-box">
              <div className="b-logo-div">
                <img
                  src={logo1Img}
                  alt=""
                  style={{ maxHeight: 130 }}
                />
              </div>
              <div className="brought-line" />
              <div className="brought-name">{intl.formatMessage(messages.legatumName)}</div>
              <p>
                {intl.formatMessage(messages.legatumText)}
              </p>
              <div className="arrow">
                <a href="https://www.legatum.com/" target="_blank" rel="noreferrer">
                  <ArrowCircleRightIcon />
                </a>
              </div>
            </div>
            <div className="brought-box">
              <div className="b-logo-div">
                <img src={oxfordLogoImg} alt="" />
              </div>
              <div className="brought-line" />
              <div className="brought-name">{intl.formatMessage(messages.oxfordName)}</div>
              <p>
                {intl.formatMessage(messages.oxfordText)}
              </p>
              <div className="arrow">
                <a href="https://www.oxfordcharacter.org/" target="_blank" rel="noreferrer">
                  <ArrowCircleRightIcon />
                </a>
              </div>
            </div>
            <div className="brought-box">
              <div className="b-logo-div">
                <img src={harvardLogoImg} alt="" style={{ maxHeight: '100%' }} />
              </div>
              <div className="brought-line" />
              <div className="brought-name">{intl.formatMessage(messages.harvardName)}</div>
              <p>
                {intl.formatMessage(messages.harvardText)}
              </p>
              <div className="arrow">
                <a href="https://hfh.fas.harvard.edu/" target="_blank" rel="noreferrer">
                  <ArrowCircleRightIcon />
                </a>
              </div>
            </div>
          </div>
          {footerContent}
        </div>
      </div>
    </>
  );
};

export default BroughtToYou;
